import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { Observable, interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Pipe({
  name: 'counting'
})
export class CountingPipe implements PipeTransform, OnDestroy {
  private currentNumber: number = 0;
  private subscription: Subscription;

  transform(maxNumber: number): Observable<number> {
    return new Observable<number>(observer => {
      this.subscription = interval(.1).pipe(
        takeWhile(() => this.currentNumber <= maxNumber)
      ).subscribe(() => {
        observer.next(this.currentNumber++);
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
